/**
 * @generated SignedSource<<11eb024575db72eea139959e577b119e>>
 * @relayHash 5c3d27f98f8ff4a07ed5dcabf41b618e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74c8971eb51d59c41872874d3fc381abb352d5d550b613346407aaf101f42728

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceContentPosition = "AFTER" | "APPEND" | "BEFORE" | "%future added value";
export type ConfluenceContentRestrictionStateInput = "EDIT_RESTRICTED" | "OPEN" | "VIEW_RESTRICTED" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceMoveRequestInput = {
  position: ConfluenceContentPosition;
  targetId: string;
};
export type PageRestrictionsInput = {
  includeInvites?: boolean | null | undefined;
  read?: PageRestrictionInput | null | undefined;
  update?: PageRestrictionInput | null | undefined;
};
export type PageRestrictionInput = {
  group?: ReadonlyArray<PageGroupRestrictionInput> | null | undefined;
  user?: ReadonlyArray<PageUserRestrictionInput> | null | undefined;
};
export type PageGroupRestrictionInput = {
  id?: string | null | undefined;
  name: string;
};
export type PageUserRestrictionInput = {
  id: string;
};
export type ConfluenceContentPermissionsInput = {
  edit?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null | undefined> | null | undefined;
  view?: ReadonlyArray<ConfluenceContentPermissionPrincipalInput | null | undefined> | null | undefined;
};
export type ConfluenceContentPermissionPrincipalInput = {
  id: string;
  type: ConfluencePrincipalType;
};
export type usePublishUpdateBlogMutation$variables = {
  cloudId: string;
  content: string;
  contentId: string;
  message?: string | null | undefined;
  moveRequest?: ConfluenceMoveRequestInput | null | undefined;
  ncsStepVersion: string;
  permissions?: ConfluenceContentPermissionsInput | null | undefined;
  restrictionState?: ConfluenceContentRestrictionStateInput | null | undefined;
  restrictions?: PageRestrictionsInput | null | undefined;
  schedulePublishDate?: string | null | undefined;
  spaceKey: string;
  suppressNotifyWatchers?: boolean | null | undefined;
  title: string;
  version: number;
};
export type usePublishUpdateBlogMutation$data = {
  readonly confluence_updateBlogPost: {
    readonly content: {
      readonly space: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type usePublishUpdateBlogMutation = {
  response: usePublishUpdateBlogMutation$data;
  variables: usePublishUpdateBlogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "message"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "moveRequest"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ncsStepVersion"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "permissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictionState"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "restrictions"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schedulePublishDate"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suppressNotifyWatchers"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "version"
},
v14 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentBody",
            "variableName": "content"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "minorEdit",
            "variableName": "suppressNotifyWatchers"
          },
          {
            "kind": "Variable",
            "name": "moveRequest",
            "variableName": "moveRequest"
          },
          {
            "kind": "Variable",
            "name": "ncsStepVersion",
            "variableName": "ncsStepVersion"
          },
          {
            "kind": "Variable",
            "name": "permissions",
            "variableName": "permissions"
          },
          {
            "kind": "Variable",
            "name": "restrictionState",
            "variableName": "restrictionState"
          },
          {
            "kind": "Variable",
            "name": "restrictions",
            "variableName": "restrictions"
          },
          {
            "kind": "Variable",
            "name": "schedulePublishDate",
            "variableName": "schedulePublishDate"
          },
          {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          },
          {
            "kind": "Variable",
            "name": "versionMessage",
            "variableName": "message"
          }
        ],
        "kind": "ObjectValue",
        "name": "confluenceContentInput"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": "draft"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "success"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "message"
},
v18 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v19 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePublishUpdateBlogMutation",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "ConfluenceUpdateBlogPostPayload",
        "kind": "LinkedField",
        "name": "confluence_updateBlogPost",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePublishUpdateBlogMutation",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "ConfluenceUpdateBlogPostPayload",
        "kind": "LinkedField",
        "name": "confluence_updateBlogPost",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v19/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v19/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5c3d27f98f8ff4a07ed5dcabf41b618e",
    "id": "74c8971eb51d59c41872874d3fc381abb352d5d550b613346407aaf101f42728",
    "metadata": {},
    "name": "usePublishUpdateBlogMutation",
    "operationKind": "mutation",
    "text": "mutation usePublishUpdateBlogMutation($contentId:ID!,$content:String!,$message:String,$spaceKey:String!,$suppressNotifyWatchers:Boolean,$ncsStepVersion:String!,$title:String!,$version:Int!,$schedulePublishDate:String,$moveRequest:ConfluenceMoveRequestInput,$restrictions:PageRestrictionsInput,$cloudId:ID!,$restrictionState:ConfluenceContentRestrictionStateInput,$permissions:ConfluenceContentPermissionsInput){confluence_updateBlogPost(cloudId:$cloudId,input:{confluenceContentInput:{contentBody:$content,contentId:$contentId,minorEdit:$suppressNotifyWatchers,moveRequest:$moveRequest,ncsStepVersion:$ncsStepVersion,restrictions:$restrictions,schedulePublishDate:$schedulePublishDate,spaceKey:$spaceKey,title:$title,version:$version,versionMessage:$message,restrictionState:$restrictionState,permissions:$permissions},status:\"draft\"}){success,content{space{name,id},id},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "403dcae9319894e332650a21b7093b87";

export default node;
